<script lang="ts">
	import {
		marginInputForTrade,
		executionType,
		userMarginBalanceForTrade,
		longOrShort,
		isTPSLActive,
		isAddMaxMargin
	} from './store';

	import BigNumber from 'bignumber.js';
	import { addDollarSign, getNumBackInUnits, toBN } from '$lib/util/util';
	import { smartWalletCreationPending, walletConnected, walletLoaded } from '$lib/wallet/store';
	import MarginInputTrade from './MarginInputTrade.svelte';
	import { checkingSmartContractWallet, smartContractWalletAddress } from '../scwallet/store';
	import LeverageInput from './LeverageInput.svelte';
	import LimitOrderSection from './LimitOrderSection.svelte';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import TakeProfitAndStopLossInput from './TakeProfitAnsStopLoss/TakeProfitAndStopLossInput.svelte';
	import StopOrderSection from './StopOrderSection.svelte';
	import { getPostTradeDetails } from '$lib/data/userInteract';
	import { onDestroy } from 'svelte';
	import { currentMarketAsset } from '../store';

	let marginInput: string;
	let insufficientMargin: boolean;
	export let isMarginInputAmountGTMax: boolean;

	function setMarginInputAsMax() {
		isAddMaxMargin.set(true);
		marginInput = getNumBackInUnits($userMarginBalanceForTrade, 18, 18);
		if (marginInput) marginInputForTrade.set(toBN(marginInput).toString());
		else marginInputForTrade.set('0');
	}
	$: isMarginInputAmountGTMax =
		new BigNumber($marginInputForTrade).gt($userMarginBalanceForTrade) &&
		$walletLoaded &&
		$walletConnected &&
		!$checkingSmartContractWallet &&
		$smartWalletCreationPending == false;

	const handleToggleTPSL = () => {
		isTPSLActive.set(!$isTPSLActive);
		getPostTradeDetails();
	};

	let longOrShortListener = longOrShort.subscribe((value) => {
		isAddMaxMargin.set(false);
	});

	let executionTypeListener = executionType.subscribe((value) => {
		isAddMaxMargin.set(false);
	});

	onDestroy(() => {
		longOrShortListener();
		executionTypeListener();
	});
</script>

<div class="w-full relative">
	<div>
		{#if !$walletLoaded || $walletConnected}
			<div class="flex w-full justify-between">
				<div>
					<div class="text-fx-grey-400 text-xs flex">
						<Tooltip
							header="Available Margin Balance"
							title="The sum of your smart wallet balance and the margins in markets where you don’t have any open positions. Unused margin has higher pref."
							>Balance:</Tooltip
						>
						{#if $smartContractWalletAddress && $userMarginBalanceForTrade}
							<span class="text-fx-grey-200 font-semibold mx-1" data-testid="margin-available">
								{addDollarSign(getNumBackInUnits($userMarginBalanceForTrade, 18, 2))}
							</span>
							{#if !$isAddMaxMargin}
								<button
									class="text-fx-blue cursor-pointer underline"
									on:click={setMarginInputAsMax}
									on:keydown={setMarginInputAsMax}
								>
									max
								</button>
							{/if}
						{:else if $smartWalletCreationPending}
							<span class="text-fx-grey-200 font-semibold mx-1"> $0 </span>
						{:else}
							<div
								class="animate-pulse bg-fx-grey-800 h-4 col-span-2 rounded-lg squircle-lg w-10 mx-auto"
							/>
						{/if}
					</div>
				</div>
			</div>
		{/if}

		<MarginInputTrade bind:marginInput bind:isMarginInputAmountGTMax />
		{#if $executionType == 'Limit'}
			{#if $longOrShort == 'Long'}
				<LimitOrderSection isLong={true} />
			{:else}
				<LimitOrderSection isLong={false} />
			{/if}
		{/if}

		{#if $executionType == 'Stop'}
			{#if $longOrShort == 'Long'}
				<StopOrderSection isLong={true} />
			{:else}
				<StopOrderSection isLong={false} />
			{/if}
		{/if}

		<LeverageInput bind:insufficientMargin />
		<button
			class="mt-4 border-t border-fx-grey-300/20 pt-3 flex justify-between items-center cursor-pointer w-full"
			on:click={handleToggleTPSL}
			on:keydown={handleToggleTPSL}
		>
			<div class="text-xs text-fx-grey-200 font-medium">Take Profit/Stop Loss</div>
			<div class="flex">
				<input
					type="checkbox"
					class="checked:bg-fx-gradient-14 bg-fx-grey-800 p-1 border-fx-blue appearance-none w-4 h-4 rounded cursor-pointer"
					class:border-2={!$isTPSLActive}
					bind:checked={$isTPSLActive}
				/>
			</div>
		</button>
		{#if $isTPSLActive}
			<TakeProfitAndStopLossInput />
		{/if}
	</div>
</div>
